import type { InboxAlertsTranslation } from './en';

/** Hindi. Pending review by native speakers, as the note in the interface says. */
export const inboxAlertsHi: InboxAlertsTranslation = {
  status: {
    label: 'आपकी स्थिति',
    online: 'ऑनलाइन',
    away: 'दूर',
    offline: 'ऑफ़लाइन',
    hint: 'ग्राहकों को यह बताया जाता है कि कोई व्यक्ति ऑनलाइन है, केवल तभी जब जवाब दे सकने वाला कोई सदस्य ऑनलाइन हो।',
    idle: 'आपकी टीम आपको दूर देखती है: कुछ मिनट से Studio का उपयोग नहीं हुआ है।',
    changed: 'आपकी स्थिति अब {{status}} है।',
    teammate: '{{name}}, {{status}}',
  },
  settings: {
    button: 'अलर्ट',
    title: 'आवाज़ें और डेस्कटॉप अलर्ट',
    description: 'ये सेटिंग केवल आपकी हैं। हर साथी की अपनी सेटिंग रहती है।',
    mute: 'सभी आवाज़ें म्यूट करें',
    muteHint: 'डेस्कटॉप अलर्ट और ब्राउज़र टैब की गिनती फिर भी काम करती रहेगी।',
    volume: 'आवाज़ का स्तर',
    volumeValue: '{{value}} प्रतिशत',
    silent: 'आवाज़ें म्यूट होने पर या आवाज़ का स्तर 0 होने पर कोई आवाज़ नहीं बजेगी।',
    events: {
      title: 'हर घटना के लिए आवाज़',
      newChat: 'कोई चैट किसी व्यक्ति का इंतज़ार कर रही है, या जवाब का समय निकल गया है',
      customerMessage: 'कोई ग्राहक आपकी चैट में, या ऐसी चैट में लिखता है जिसे किसी ने नहीं लिया',
      assigned: 'कोई चैट आपको पेश, सौंपी या ट्रांसफ़र की गई',
    },
    sounds: {
      chime: 'घंटी की धुन',
      pop: 'पॉप',
      bell: 'घंटा',
      drop: 'बूँद',
      ping: 'पिंग',
      none: 'कोई आवाज़ नहीं',
    },
    play: '{{sound}} बजाएँ',
    blocked: 'आपके ब्राउज़र ने आवाज़ बंद रखी। पेज पर कहीं एक बार क्लिक करें, फिर दोबारा कोशिश करें।',
    saveFailed: 'आपका पिछला बदलाव सहेजा नहीं जा सका। सेटिंग वही दिखाती हैं जो सहेजा हुआ है।',
    desktop: {
      title: 'डेस्कटॉप अलर्ट',
      enabled: 'Studio पृष्ठभूमि में हो तो डेस्कटॉप अलर्ट दिखाएँ',
      enabledHint: 'आप कहीं और हों, तब हर नई चैट, संदेश या असाइनमेंट पर एक अलर्ट मिलता है।',
      preview: 'ग्राहक के संदेश की शुरुआत दिखाएँ',
      previewHint: 'अगर दूसरे लोग आपकी स्क्रीन देख सकते हैं तो इसे बंद करें।',
      unsupported: 'यह ब्राउज़र डेस्कटॉप अलर्ट नहीं दिखा सकता।',
      prompt: 'आपका ब्राउज़र अनुमति माँगेगा। “अनुमति दें” चुनें।',
      allow: 'डेस्कटॉप अलर्ट की अनुमति दें',
      granted: 'इस ब्राउज़र में डेस्कटॉप अलर्ट की अनुमति है।',
      denied:
        'इस ब्राउज़र में डेस्कटॉप अलर्ट बंद हैं। इन्हें चालू करने के लिए ब्राउज़र सेटिंग में इस साइट के लिए सूचनाओं की अनुमति दें, फिर यह पेज दोबारा लोड करें।',
      test: 'टेस्ट अलर्ट भेजें',
      testTitle: 'Hamnivo टेस्ट अलर्ट',
      testBody: 'डेस्कटॉप अलर्ट ऐसा दिखता है। Studio में लौटने के लिए इस पर क्लिक करें।',
    },
  },
  banner: {
    title: 'Studio पृष्ठभूमि में हो तब भी नई चैट की जानकारी पाएँ',
    description:
      'दूसरे टैब या विंडो में काम करते समय नई चैट और संदेशों की जानकारी पाने के लिए डेस्कटॉप अलर्ट की अनुमति दें।',
    allow: 'डेस्कटॉप अलर्ट की अनुमति दें',
    later: 'अभी नहीं',
  },
  alert: {
    chat_waiting: '{{name}} किसी व्यक्ति का इंतज़ार कर रहे हैं',
    sla_overdue: '{{name}} के जवाब का समय निकल गया है',
    sla_overdue_lead: '{{name}} को किसी ने समय पर जवाब नहीं दिया',
    chat_offered: '{{name}} की चैट आपको पेश की गई है: स्वीकार करें या मना करें',
    customer_message: '{{name}} का नया संदेश',
    assigned: 'आपको एक चैट सौंपी गई',
    assignedBody: '{{name}}: {{preview}}',
    open: 'पढ़ने के लिए चैट खोलें।',
  },
  unread: {
    row: 'अपठित संदेश: {{count}}',
  },
  typing: {
    customer: '{{name}} लिख रहे हैं…',
  },
  visitor: {
    title: 'वेबसाइट पर विज़िट',
    notNoted: 'यह ब्रांड दर्ज नहीं करता कि विज़िटर कौन-से पेज देखते हैं।',
    none: 'इस ग्राहक के लिए कोई पेज दर्ज नहीं है। हो सकता है वे “Do Not Track” इस्तेमाल करते हों, या चैट ऐसी जगह खुली हो जहाँ वेबसाइट की चैट स्क्रिप्ट नहीं चलती।',
    online: 'अभी वेबसाइट पर हैं',
    left: 'वेबसाइट छोड़ी {{when}}',
    currentPage: 'मौजूदा पेज',
    entryPage: 'यहाँ से आए',
    visits: 'विज़िट',
    visitor: 'विज़िटर',
    returning: 'दोबारा आया',
    new: 'नया',
    timeOnSite: 'साइट पर समय',
    underMinute: 'एक मिनट से कम',
    country: 'देश',
    device: 'डिवाइस',
    language: 'भाषा',
    cameFrom: 'कहाँ से आए',
    pages: 'इस विज़िट के पेज',
    untitled: 'बिना शीर्षक का पेज',
    openPage: '{{page}} को नए टैब में खोलें',
    types: { desktop: 'कंप्यूटर', mobile: 'फ़ोन', tablet: 'टैबलेट', other: 'डिवाइस' },
    privacy: 'पेज बिना क्वेरी स्ट्रिंग के दर्ज होते हैं और 30 दिन रखे जाते हैं। कोई IP पता सहेजा नहीं जाता।',
  },
  live: {
    link: 'लाइव विज़िटर',
    title: 'लाइव विज़िटर',
    description: 'अभी आपकी वेबसाइटों पर मौजूद लोग। सूची हर कुछ सेकंड में अपडेट होती है।',
    back: 'इनबॉक्स पर वापस जाएँ',
    brand: 'ब्रांड',
    allBrands: 'सभी ब्रांड',
    loading: 'विज़िटर लोड हो रहे हैं',
    summary: 'अभी वेबसाइट पर: {{number}}',
    updated: 'अपडेट किया गया {{time}}',
    table: 'अभी वेबसाइट पर मौजूद विज़िटर',
    columns: {
      visitor: 'विज़िटर',
      page: 'पेज',
      time: 'साइट पर समय',
      country: 'देश',
      device: 'डिवाइस',
      visits: 'विज़िट',
      actions: 'कार्रवाइयाँ',
    },
    returning: 'दोबारा आया · {{number}}',
    new: 'नया',
    openChat: 'चैट खोलें',
    openChatFor: '{{name}} के साथ चैट खोलें',
    invite: 'चैट शुरू करें',
    inviteFor: '{{name}} के साथ चैट शुरू करें',
    empty: {
      title: 'अभी आपकी वेबसाइट पर कोई नहीं है',
      description:
        'विज़िटर तब तक यहाँ दिखते हैं जब तक उनका कोई पेज खुला है। इसके लिए आपकी वेबसाइट पर चैट स्क्रिप्ट और ब्रांड के लिए पेज ट्रैकिंग चालू होना ज़रूरी है।',
    },
    forbidden: {
      title: 'लाइव विज़िटर आपके लिए उपलब्ध नहीं हैं',
      description: 'आपकी भूमिका में बातचीत पढ़ना शामिल नहीं है।',
    },
    dialog: {
      title: '{{name}} के साथ चैट शुरू करें',
      description:
        'आपका संदेश उस पेज पर चैट बटन के पास दिखता है जिसे वे देख रहे हैं। अगर वे इसे खोलते हैं तो चैट आपके शब्दों से शुरू होती है।',
      message: 'आपका संदेश',
      hint: 'अधिकतम 300 अक्षर।',
      default: 'नमस्ते! क्या मैं कुछ ढूँढने में आपकी मदद कर सकता हूँ?',
      send: 'निमंत्रण भेजें',
      sent: 'निमंत्रण भेजा गया। यह कुछ सेकंड में दिखेगा और 3 मिनट तक इंतज़ार करेगा।',
      gone: 'यह विज़िटर वेबसाइट छोड़ चुका है।',
    },
    settings: {
      title: 'विज़िटर ट्रैकिंग',
      description: 'चुनें कि कोई ब्रांड दर्ज करे या नहीं कि विज़िटर कौन-से पेज देखते हैं।',
      brand: 'ब्रांड',
      tracking: 'दर्ज करें कि विज़िटर कौन-से पेज देखते हैं',
      trackingHint:
        'डिफ़ॉल्ट रूप से चालू। जिन विज़िटरों का ब्राउज़र “Do Not Track” या “Global Privacy Control” भेजता है, वे हमेशा बाहर रहते हैं, और चैट विज़िटरों को बताती है कि पेज दर्ज होते हैं।',
      queries: 'पेज पते में प्रश्नचिह्न के बाद का हिस्सा रखें',
      queriesHint:
        'डिफ़ॉल्ट रूप से बंद: कुछ भी सहेजने से पहले इसे हटा दिया जाता है, क्योंकि इसमें ईमेल पते या ऑर्डर नंबर हो सकते हैं। चालू होने पर भी पासवर्ड या टोकन जैसे मान हटा दिए जाते हैं।',
      retention:
        'विज़िटर को आख़िरी बार देखे जाने के 30 दिन बाद पेज और विज़िट हटा दिए जाते हैं। कोई IP पता सहेजा नहीं जाता।',
      save: 'सहेजें',
      saved: 'सहेजा गया। यह हर विज़िटर के अगले पेज व्यू से लागू होता है।',
    },
  },
  library: {
    link: 'सहेजे गए जवाब और टैग',
    title: 'सहेजे गए जवाब और टैग',
    description:
      'आपकी टीम के साझा तैयार जवाब और लेबल। कोई भी बदलाव इस ब्रांड के लिए ग्राहकों को जवाब देने वाले सभी लोगों पर लागू होता है।',
    back: 'इनबॉक्स पर वापस जाएँ',
    brand: 'ब्रांड',
    loading: 'सहेजे गए जवाब और टैग लोड हो रहे हैं',
    noBrands: 'अभी कोई ब्रांड नहीं है। सहेजे गए जवाब और टैग ब्रांड की चैट से जुड़े होते हैं।',
    notSetUp: {
      title: '{{name}} के लिए चैट अभी सेट अप नहीं है',
      description: 'पहले ब्रांड को चैट से जोड़ें। उसके बाद उसके सहेजे गए जवाब और टैग यहाँ सेट कर सकते हैं।',
      action: 'ब्रांड और इंस्टॉल खोलें',
    },
    forbidden: {
      title: 'सहेजे गए जवाब और टैग आपके लिए उपलब्ध नहीं हैं',
      description: 'आपकी भूमिका में इनबॉक्स प्रबंधित करना शामिल नहीं है। किसी एडमिन से मदद माँगें।',
    },
    hint: {
      add: 'टैग जोड़ें',
      ask: 'जो इनबॉक्स प्रबंधित करता है, उससे इन्हें जोड़ने को कहें।',
    },
    replies: {
      title: 'सहेजे गए जवाब',
      description:
        'आपकी टीम इन्हें जवाब वाले बॉक्स के पास "सहेजे गए जवाब" बटन से चुनती है। ग्राहक का नाम जैसी जानकारी चैट से भर जाती है।',
      add: 'सहेजा हुआ जवाब जोड़ें',
      search: 'सहेजे गए जवाब खोजें',
      noMatch: 'आपकी खोज से कोई सहेजा गया जवाब मेल नहीं खाता।',
      table: 'इस ब्रांड के सहेजे गए जवाब',
      columns: { code: 'शॉर्ट कोड', text: 'पाठ', actions: 'कार्रवाइयाँ' },
      edit: 'बदलें',
      editFor: 'सहेजे गए जवाब {{code}} को बदलें',
      delete: 'हटाएँ',
      deleteFor: 'सहेजे गए जवाब {{code}} को हटाएँ',
      empty: {
        title: 'अभी कोई सहेजा गया जवाब नहीं',
        description:
          'वे जवाब जोड़ें जो आपकी टीम बार-बार लिखती है, जैसे खुलने का समय या रिटर्न कैसे काम करता है।',
      },
      added: 'सहेजा गया जवाब {{code}} जोड़ा गया।',
      saved: 'सहेजा गया जवाब {{code}} सहेजा गया।',
      deleted: 'सहेजा गया जवाब {{code}} हटाया गया।',
      dialog: {
        addTitle: 'सहेजा हुआ जवाब जोड़ें',
        editTitle: 'सहेजे गए जवाब {{code}} को बदलें',
        description: 'इस ब्रांड के लिए ग्राहकों को जवाब देने वाला हर व्यक्ति इसे तुरंत इस्तेमाल कर सकता है।',
        code: 'शॉर्ट कोड',
        codeHint:
          'एक छोटा नाम जिसे आपकी टीम खोज सके, जैसे refund-policy। केवल अक्षर, अंक, - और _, खाली जगह नहीं।',
        codeRequired: 'शॉर्ट कोड लिखें।',
        codeInvalid: 'केवल अक्षर, अंक, - और _ इस्तेमाल करें (खाली जगह नहीं), अधिकतम 40 अक्षर।',
        codeTaken: 'कोई दूसरा सहेजा गया जवाब यही शॉर्ट कोड इस्तेमाल करता है।',
        text: 'पाठ',
        textHint: 'अधिकतम {{number}} अक्षर।',
        textRequired: 'जवाब का पाठ लिखें।',
        details: 'चैट से कोई जानकारी जोड़ें',
        detailsHint:
          'जवाब इस्तेमाल होते समय यह भर जाती है। अगर जानकारी न हो, तो व्यक्ति से उसे खुद भरने को कहा जाता है।',
        detail: {
          firstName: 'ग्राहक का पहला नाम',
          name: 'ग्राहक का पूरा नाम',
          agent: 'आपका नाम',
          brand: 'ब्रांड का नाम',
        },
        save: 'सहेजें',
        add: 'जवाब जोड़ें',
      },
      confirm: {
        title: 'सहेजा गया जवाब {{code}} हटाएँ?',
        body: 'यह आपकी टीम में सभी के लिए गायब हो जाएगा। पहले भेजे जा चुके संदेश नहीं बदलते।',
        action: 'सहेजा गया जवाब हटाएँ',
      },
    },
    tags: {
      title: 'टैग',
      description:
        'आपकी टीम चैट को छाँटने और ढूँढने के लिए जो लेबल लगाती है। स्टाफ इन्हें चैट के विवरण पैनल में जोड़ता है।',
      add: 'टैग जोड़ें',
      table: 'इस ब्रांड के टैग',
      columns: { name: 'नाम', description: 'विवरण', actions: 'कार्रवाइयाँ' },
      edit: 'बदलें',
      editFor: 'टैग {{name}} को बदलें',
      delete: 'हटाएँ',
      deleteFor: 'टैग {{name}} को हटाएँ',
      empty: {
        title: 'अभी कोई टैग नहीं',
        description: 'vip या refund जैसे टैग जोड़ें, ताकि आपकी टीम चैट छाँट सके।',
      },
      added: 'टैग {{name}} जोड़ा गया।',
      saved: 'टैग {{name}} सहेजा गया।',
      deleted: 'टैग {{name}} हटाया गया।',
      dialog: {
        addTitle: 'टैग जोड़ें',
        editTitle: 'टैग {{name}} को बदलें',
        description: 'आपकी टीम इसे तुरंत चैट पर लगा सकती है।',
        name: 'नाम',
        nameHint:
          'कम से कम 2 अक्षर या अंक; पहले के बाद - और _ चल सकते हैं, जैसे vip या order-problem। इसे छोटे अक्षरों में रखा जाता है।',
        nameRequired: 'टैग का नाम लिखें।',
        nameInvalid:
          '2 से 50 अक्षर या अंक इस्तेमाल करें; पहले के बाद - और _ चल सकते हैं, खाली जगह नहीं। मात्राओं वाले अक्षर (जैसे हिंदी में) चैट सेवा स्वीकार नहीं करती: नाम अंग्रेज़ी अक्षरों में लिखें।',
        nameTaken: 'इस नाम का टैग पहले से है।',
        renameNote: 'नाम बदलने से यह टैग उन सभी चैट में बदल जाता है जिनमें यह लगा है।',
        descriptionLabel: 'विवरण',
        descriptionHint: 'वैकल्पिक। अधिकतम {{number}} अक्षर।',
        color: 'रंग',
        colorChosen: 'चुना गया रंग: {{name}}',
        save: 'सहेजें',
        add: 'टैग जोड़ें',
      },
      colors: {
        blue: 'नीला',
        green: 'हरा',
        teal: 'हरा-नीला',
        orange: 'नारंगी',
        red: 'लाल',
        pink: 'गुलाबी',
        purple: 'बैंगनी',
        grey: 'स्लेटी',
        custom: 'अपनी पसंद ({{hex}})',
      },
      confirm: {
        title: 'टैग {{name}} हटाएँ?',
        body: 'यह उस सूची से और उन सभी चैट से हट जाता है जिनमें यह लगा है।',
        action: 'टैग हटाएँ',
      },
    },
  },
};
